import { createContext } from "react";

const SystemIdContext = createContext();

export default SystemIdContext;
